import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'upsc-product-disclosures',
  templateUrl: './product-disclosures.component.html',
  styleUrls: ['./product-disclosures.component.scss']
})
export class ProductDisclosureComponent implements OnInit {

  ngOnInit(): void {
  }
}